
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agents/[region]",
      function () {
        return require("private-next-pages/agents/[region]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agents/[region]"])
      });
    }
  